'use strict';



document.DEV_MODE = true;
document.app = {};
document.app.devmode = {};
document.app.dadata = {};



document.isReady = false;

const isDisplay = function(element){
	if(element.style.display == 'block') return true;
	else return false;
}
const  toggleDisplay = function(element){


	if(!isDisplay(element)) {
		element.style.display = 'block';
	}
	else {
		element.style.display = 'none';
	}
}

	function getId(url) {
		//console.log('url', url);
		const regExp = /^.*(youtu.be|youtube.com\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|si=)([^#&?]*).*/;
		const match = url.match(regExp);

		//console.log(match);

		let result =  (match && match[2].length === 11)
		  ? match[2]
		  : null;

		  if (!result) {
		  	const regExp = /^.*(youtu.be|youtube.com)\/([^#&?]*).*/;
			const match = url.match(regExp);

			//console.log(match);

			result =  (match && match[2].length === 11)
			  ? match[2]
			  : null;
		  }


		return result;
	}

let isDef = (name) => typeof name == 'undefined' ? false : true;

//---- Add Document Events ----

document.ready = new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));

document.ready.then(() => {
	document.isReady = true;



	const del = document.querySelectorAll('.delete-control');


	
	if (del) {
		del.forEach(element => {

			element.classList.remove('initial-state');

			element.addEventListener('click', (e) => {
				e.preventDefault();
				//let target = event.target;

				if (confirm("Вы действительно хотите удалить этот объект?")) {


  window.location.href = element.href;



				}
			})
		})
	}


	

	const messages = document.querySelectorAll('.post-content');
	//let regexp = /\s*(https?:\/\/(?:www\.)?youtu[^\s]+)\s*/g;
	
	if (messages) {
		messages.forEach(message => {
			let text = message.textContent;
			//here is regexp
			let regexp = /\s*(https?:\/\/(?:www\.)?youtu[^\s]+)\s*/g;

			let matchAll = text.matchAll(regexp);
			matchAll = Array.from(matchAll); 

			matchAll.forEach(href => {

				//console.log('href', href);

				if (isDef(href[1])) {
					const videoId = getId(href[1]);

				//console.log('videoId', videoId);

				if (videoId) {

					const iframeContainer = document.createElement('div');
					iframeContainer.classList.add('youtube-inline');

					const iframe = document.createElement('iframe');
    				
					iframe.src = '//www.youtube.com/embed/' + videoId;
					iframe.loading = 'lazy';
					iframe.width = '560';
					iframe.height = '315';
					iframe.allowfullscreen = 'allowfullscreen';

    				iframeContainer.appendChild(iframe);
    				message.appendChild(iframeContainer);

    				const timer = setTimeout(((iframe, iframeContainer) => {
    					
    					//iframe.contentWindow.stop();
    					//iframe.remove();
    					//iframeContainer.innerHTML = '<p style="font-weight:bold;font-size:1.1em">Video unavailable</p>';

    				}).bind(null, iframe, iframeContainer), 8000);

    				iframe.addEventListener('DOMContentLoaded', ()=> {
    					clearTimer(timer);
    				})


					//const iframeMarkup = '<div><iframe loading="lazy" width="560" height="315" src="//www.youtube.com/embed/' + videoId + '" frameborder="0" allowfullscreen></iframe></div>';

					//message.innerHTML = message.innerHTML + iframeMarkup;
					
				}
				}
				
				
			})

		})
	}



	const iframes = document.querySelectorAll('iframe');


	
	if (iframes) {
		iframes.forEach(element => {
			const width = parseInt(element.width);
			const height = parseInt(element.height);

			if (width) {
				const unitW = element.width.substring(width.toString().length);
			
				if (height) {
					const unitH = element.height.substring(height.toString().length);

					if (unitH == unitW)  {
						element.style.aspectRatio = width / height;
					}
				}
			}


		})
	}

	
	

	
});
		


